import { render, staticRenderFns } from "./About_VersionControl.vue?vue&type=template&id=7f183a92&scoped=true"
import script from "./About_VersionControl.vue?vue&type=script&lang=js"
export * from "./About_VersionControl.vue?vue&type=script&lang=js"
import style0 from "./About_VersionControl.vue?vue&type=style&index=0&id=7f183a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f183a92",
  null
  
)

export default component.exports